import { ExpandMore } from "@mui/icons-material";
import { Box } from "@mui/material";
import React from "react";

import type { SidebarMenuItemCollapseIconProps } from "./types";
import { sidebarTheme } from "@/styles/sidebarTheme";

export const SidebarMenuItemCollapseIcon: React.FC<
  SidebarMenuItemCollapseIconProps
> = ({ isExpanded }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
      }}
    >
      <ExpandMore
        sx={{
          color: sidebarTheme.menu.collapse.icon,
          fontSize: 24,
        }}
      />
    </Box>
  );
};
